<ul *ngIf="null !== messages" class="errorMessages">
    <li *ngFor="let error of messages">
        {{error}}
    </li>
</ul>